import React from "react";
import { Container, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const UserNotAuthorized = () => {
  const { t } = useTranslation("pages", { keyPrefix: "PageUnauthorized" });

  return (
    <Container maxWidth="sm" style={{ textAlign: "center", marginTop: "5em" }}>
      <Typography variant="h1" gutterBottom>
        401
      </Typography>
      <Typography variant="h4" gutterBottom>
        {t("Not Authorized")}
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        {t("Sorry, you are not authorized to access this page.")}
      </Typography>
      <Button variant="contained" color="primary" component={Link} to="/">
        {t("Go Home")}
      </Button>
    </Container>
  );
};
